{
  class TopCountdown extends HTMLElement {
    connectedCallback() {
      if (this._abortController) return

      this._abortController = new AbortController()
      this.hidden = false

      this._endAt = this._parseDate(this.dataset.endAt)
      const serverNow = this._parseDate(this.dataset.serverNow)
      this._clockOffset = serverNow === null ? 0 : serverNow - Date.now()

      if (this._endAt === null) return
      if (!this._renderTick()) return

      this._timer = setInterval(() => this._renderTick(), 1000)
    }

    disconnectedCallback() {
      if (this._timer !== undefined) {
        clearInterval(this._timer)
        this._timer = undefined
      }

      this._abortController?.abort()
      this._abortController = undefined
    }

    _parseDate(value) {
      if (!value) return null
      const timestamp = Date.parse(value.includes('T') ? value : value.replace(' ', 'T'))
      return Number.isFinite(timestamp) ? timestamp : null
    }

    _renderTick() {
      const remaining = this._endAt - (Date.now() + this._clockOffset)
      if (remaining <= 0) {
        this._write('[data-days]', '00')
        this._write('[data-hours]', '00')
        this._write('[data-minutes]', '00')
        this._write('[data-seconds]', '00')

        if (this._timer !== undefined) {
          clearInterval(this._timer)
          this._timer = undefined
        }
        return false
      }

      const seconds = Math.floor(remaining / 1000) % 60
      const minutes = Math.floor(remaining / 60_000) % 60
      const hours = Math.floor(remaining / 3_600_000) % 24
      const days = Math.floor(remaining / 86_400_000)

      this._write('[data-days]', String(days))
      this._write('[data-hours]', String(hours).padStart(2, '0'))
      this._write('[data-minutes]', String(minutes).padStart(2, '0'))
      this._write('[data-seconds]', String(seconds).padStart(2, '0'))
      return true
    }

    _write(selector, value) {
      const target = this.querySelector(selector)
      if (target) target.textContent = value
    }
  }

  if (!customElements.get('top-countdown')) {
    customElements.define('top-countdown', TopCountdown)
  }
}
